export default "__VITE_ASSET__CzUTy_2w__"